// extracted by mini-css-extract-plugin
export var divider = "_yx-0";